export const SERVER_BASE_URL = process.env.REACT_APP_API_URL;

export const AUTHSERVER_TOKEN = SERVER_BASE_URL + '/easysignapi/v1/Authentication/authenticate';
export const AUTHSERVER_TOKEN_REVOKE = SERVER_BASE_URL + '/auth-server/auth/user/token/revoke';

export const PROCESS_TEMPLATE_GET = '/easysignapi/v1/ProcessTemplates/All';
export const PROCESS_TEMPLATE = '/easysignapi/v1/ProcessTemplates';
export const PROCESS_TEMPLATE_SAVE = '/easysignapi/v1/ProcessTemplates/Save';

export const PROCESS_TYPE_GET = '/easysignapi/v1/ProcessTypes/All';
export const PROCESS_TYPE_GET_BY_GROUP_ID = '/easysignapi/v1/ProcessTypes/group';
export const PROCESS_TYPE = '/easysignapi/v1/ProcessTypes';

export const DEPARTMENT_GET = '/easysignapi/v1/Departments/All';
export const DEPARTMENT = '/easysignapi/v1/Departments';

export const NOTIFICATION_GET = '/easysignapi/v1/Notifications/All';
export const NOTIFICATION = '/easysignapi/v1/Notifications';

export const AUTHORIZATION_GET = '/easysignapi/v1/Authorizations/claims';
export const ROLE_GET = '/easysignapi/v1/Authorizations/roles';
export const AUTHORIZATION = '/easysignapi/v1/Authorizations';

export const PARAMETER = '/easysignapi/v1/Parameters/groups';
export const PARAMETERS_BY_GROUP_CODES = '/easysignapi/v1/Parameters/groups/groupCodes';

export const APPROVALS_GET_ALL = '/easysignapi/v1/Approvals/all';
export const APPROVALS_COUNT = '/easysignapi/v1/Approvals/counts';
export const APPROVALS_GET_WAITINGS = '/easysignapi/v1/Approvals/waiting';
export const APPROVALS_GET_ACTIVES = '/easysignapi/v1/Approvals/actives';
export const APPROVALS_GET_COMPLETEDS = '/easysignapi/v1/Approvals/completeds';
export const APPROVALS_GET_CANCELEDS = '/easysignapi/v1/Approvals/canceleds';
export const APPROVALS = '/easysignapi/v1/Approvals';
export const APPROVAL_FILE_GET = '/easysignapi/v1/Approvals/approvalFiles';
export const APPROVAL_SIGNED_FILE_GET = '/easysignapi/v1/Approvals/signedFiles';
export const APPROVAL_ADDITIONAL_FILE_GET = '/easysignapi/v1/Approvals/additionalFiles';
export const APPROVAL_FILE_VERIFY = '/easysignapi/v1/Approvals/verify';
export const APPROVAL_SIGNERS = '/easysignapi/v1/ApprovalSigners';
export const APPROVALS_FROM_TEMPLATE = '/easysignapi/v1/ApprovalsFromTemplate';

export const PROCESS_GROUP_GET = '/easysignapi/v1/ProcessGroups/All';
export const PROCESS_GROUP = '/easysignapi/v1/ProcessGroups';

export const USER_NOTIFICATION_GET = '/easysignapi/v1/UserNotifications/All';
export const USER_NOTIFICATION = '/easysignapi/v1/UserNotifications';

export const COMPANY_FTP_ADDRESS_GET = '/easysignapi/v1/CompanyContacts/ftp/All';
export const COMPANY_MAIL_ADDRESS_GET = '/easysignapi/v1/CompanyContacts/mail/All';
export const COMPANY_FTP_ADDRESS = '/easysignapi/v1/CompanyContacts/ftp';
export const COMPANY_MAIL_ADDRESS = '/easysignapi/v1/CompanyContacts/mail';

export const API_TOKEN = SERVER_BASE_URL +'/connect/token?code=';
export const API_MENU_SCREENS = SERVER_BASE_URL +'/easysignapi/v1/Authorizations/menuScreens';

export const SIGNING_SERVICE_ROUTING_GET = '/easysignapi/v1/SigningServiceRouting';
export const REPORT_PROCESS_INFORMATION_GET = '/easysignapi/v1/ProcessReport/processesinformation';
export const USERS_BY_CUSTOMER_NUMBER = '/easysignapi/v1/Authorizations/users-by-user-id';
export const CURRENT_USER = '/easysignapi/v1/Authorizations/current-user';